module.exports = __webpack_public_path__ + "../resources/img/ic-refresh.47ab7fc3.svg";